module.exports = __webpack_public_path__ + "static/img/logo1.655b524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.png
// module id = TrFT
// module chunks = 1